import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NAV } from "../../data/content";
import { useI18n } from "../../context/LanguageContext";

export default function SideNav() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [active, setActive] = useState("");
  const key = (href) => href.replace("#", "");

  useEffect(() => {
    const ids = NAV.map((n) => key(n.href));
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); }),
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    ids.forEach((id) => { const el = document.getElementById(id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, []);

  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  const Item = ({ testId, on, label, onClick }) => (
    <button data-testid={testId} onClick={onClick} className="group flex items-center gap-2 justify-end w-full">
      <span className={`font-mono-x text-[10px] tracking-[0.2em] uppercase whitespace-nowrap px-2.5 py-1 rounded-full bg-background/70 backdrop-blur border border-border opacity-0 translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 ${on ? "text-primary border-primary/40" : "text-muted-foreground"}`}>
        {label}
      </span>
      <span className={`shrink-0 rounded-full transition-all duration-200 ${on ? "w-3 h-3 bg-primary shadow-[0_0_10px_hsl(var(--primary)/0.85)]" : "w-2 h-2 bg-muted-foreground/40 group-hover:bg-primary"}`} />
    </button>
  );

  return (
    <nav data-testid="side-nav" className="hidden xl:flex fixed right-5 top-1/2 -translate-y-1/2 z-50 flex-col items-end gap-3.5">
      {NAV.map((n) => {
        const k = key(n.href);
        return <Item key={n.href} testId={`side-nav-${k}`} on={active === k} label={t(`nav.${k}`)} onClick={() => go(n.href)} />;
      })}
      <Item testId="side-nav-insights" on={false} label={t("nav.insights")} onClick={() => nav("/blog")} />
    </nav>
  );
}
